// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum RepositOfferStatus {
    PENDING = 'PENDING',
    REPOSITCHOSEN = 'REPOSIT_CHOSEN',
    CASHDEPOSITCHOSEN = 'CASH_DEPOSIT_CHOSEN'
}



